import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { CompetencyTypesService } from 'app/_services/competency-types.service';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from 'environments/environment';
import { AddCertificateModalComponent } from './add-certificate-modal/add-certificate-modal.component';
import { SiteOwnerUserService } from 'app/_services/site-owner-user.service';

@Component({
  selector: 'invite-contractor',
  templateUrl: './invite-contractor.component.html'
})
export class InviteContractorComponent implements OnInit {
  public form: any;
  public findContractorForm: any;

  public saveInProgress = false;
  public formValidated = false;
  private routeRole: any;
  public competencies = [];
  public competencyOptions = [];
  private existingContractorId: any;
  public existingContractorMode = false;
  public existingContractor: any;
  public contractorsOptionsList: any[] = [];
  public isSiteOwner: boolean;
  public isSiteDelegate: boolean;
  public isPowerStationUser: boolean;
  public siteOwners = [];
  public siteOwnerId: number;
  public selectedSiteOwner: any;
  private siteOwnerIds: number[] = [];

  public isHuntstown: boolean;
  public extraCompetencyInfo: { [competencyId: number]: string } = {};

  constructor(
    private notificationService: NotificationService,
    private contractorService: ContractorService,
    private competencyService: CompetencyTypesService,
    private siteOwnerUserService: SiteOwnerUserService,
    private modalService: NgbModal,
    private router: Router,
    private globals: Globals,
    fb: FormBuilder,
    activatedRoute: ActivatedRoute,
  ) {

    this.routeRole = globals.user.routeRole;
    this.isPowerStationUser = this.routeRole === 'power-station-owner';
    this.isSiteOwner = this.routeRole === 'site-owner';
    this.isSiteDelegate = this.routeRole === 'site-delegate' ;

    // client Huntstown specifically wants extra text displayed next to certain competencies
    if (this.isPowerStationUser) {
      this.isHuntstown = this.globals.powerStationOwner.mainSiteId === environment.HUNTSTOWN_ID;
      this.extraCompetencyInfo = environment.CONTRACTOR_COMPETENCY_ID_TO_EXTRA_INFO_TEXT;
    }

    activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.contractor) {
        this.existingContractorId = params.contractor;
        this.existingContractorMode = true;
      }
    });

    this.findContractorForm = fb.group({
      contractor: new FormControl('', [Validators.required]),
    });

    if (this.existingContractorMode) {
      this.form = fb.group({
        firstName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
        lastName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
        email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(100)]),
        phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^[^a-zA-Z]+$'), Validators.minLength(8), Validators.maxLength(30)]),
      });
    } else {
      this.form = fb.group({
        companyName: new FormControl('', [Validators.required, Validators.maxLength(255)]),
        additionalInfo: new FormControl(''),
        firstName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
        lastName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
        email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(100)]),
        phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^[^a-zA-Z]+$'), Validators.minLength(8), Validators.maxLength(30)]),
      });
    }
  }

  ngOnInit() {
    this.getSiteOwnerId();

    this.competencyService.getAllCompetencyTypesByType('POWERSTATION').subscribe((data: any) => {
      this.competencyOptions = data.map(competency => ({
        label: competency.value,
        value: {id: competency.id, label: competency.value},
      }));

      this.competencyOptions.sort((a, b) => a.label.localeCompare(b.label));

      if (this.existingContractorMode) {
        this.contractorService.getContractorById(this.existingContractorId).subscribe((result: any) => {
          this.existingContractor = result;
        });
      }
    });
 // Not possible swap getAllContractorsNoPagination for getAllContractorFullList. It needs linked site for the drop to filter alreadyAdded.
    this.contractorService.getAllContractorsNoPagination().subscribe((data: any) => {
      this.contractorsOptionsList = data.map((element) => {
        let alreadyAdded = element.maintenanceSiteOwners.some(mso => (mso.siteOwnerUser.skylarkUserId === this.siteOwnerId));

        return ({
          label: element.name,
          value: element.id,
          disabled: alreadyAdded,
        });
      });
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving contractor list');
    });
  }


  public selectedSiteOwnerChange() {
    this.siteOwnerId = this.selectedSiteOwner.id;
  }

  private getSiteOwnerId() {
    // figure out which siteowner this is for

    if (!this.siteOwnerId) {

      if (this.isSiteOwner || this.isPowerStationUser) {
        this.siteOwnerId = this.globals.siteOwnerUsers[0].skylarkUserId;

      } else if (this.isSiteDelegate) {
        this.siteOwnerIds = this.globals.siteOwnerUsers.map(sou => sou.skylarkUserId);

        if (this.siteOwnerIds.length === 1) {
          this.siteOwnerId = this.siteOwnerIds[0];

        } else {
          // for users delegated by multiple site owners, need a dropdown to choose which site owner
          this.siteOwnerUserService.getAllEnabledSiteOwnersForDropdowns().subscribe((data: any) => {
            data.forEach(element => {
              const obj = {
                label: element.firstName + ' ' + element.lastName,
                value: { id: element.id }
              };
              this.siteOwners.push(obj);
            });
          });
        }
      }
    }
  }

  public openRequiredCompetencyModal() {
    const modalOptions: NgbModalOptions = { centered: true };
    const modal = this.modalService.open(AddCertificateModalComponent, modalOptions);
    modal.componentInstance.competencyOptions = this.competencyOptions;

    modal.result
      .then((result) => {
        if (result.value && Array.isArray(result.value.competency)) {

          result.value.competency.forEach(selectedCompetency => {
            if (this.competencies.some(c => c.id === selectedCompetency.id)) {
              this.notificationService.notify('warning', selectedCompetency.label + ' already added');
            } else {
              this.competencies.push(selectedCompetency);
            }
          });

          this.competencies.sort((a, b) => a.label.localeCompare(b.label));
        }
      })
      .catch(() => {
        /* modal dismissed */
      });
  }

  public removeCompetency(removeId) {
    this.competencies = this.competencies.filter(c => c.id !== removeId);
  }

  public onSubmit() {
    this.saveInProgress = true

    const values = this.form.value;

    let body = {};

    if (this.existingContractorMode) {
      body = {
        siteOwnerSkylarkUserId: this.siteOwnerId,
        source: environment.sourceUrl,
        contractorUser: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phoneNumber: values.phoneNumber,
          login: 'xyz1234', // gets discarded on backend
          password: "Fortune!042", // gets discarded on backend
        },
        maintenanceId: this.existingContractorId,
        competencies: this.competencies.map(c => c.id),
      };
    } else {
      body = {
        siteOwnerSkylarkUserId: this.siteOwnerId,
        source: environment.sourceUrl,
        contractorUser: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phoneNumber: values.phoneNumber,
          login: 'xyz1234', // gets discarded on backend
          password: "Fortune!042", // gets discarded on backend
        },
        contractorMaintenanceCo: {
          name: values.companyName,
          additionalInfo: values.additionalInfo,
        },
        competencies: this.competencies.map(c => c.id),
      };
    }

    this.contractorService.inviteContractor(body).subscribe(result => {
      this.notificationService.notify('success', `Invites sent`);
      this.saveInProgress = false;

      this.router.navigate(['/' + this.routeRole + '/contractors']);

    }, error => {
      console.error(error);
      this.saveInProgress = false;
      this.notificationService.notify('danger', `Error creating the email invites`);
      throw error;
    });

  }

  public onFindContractorSubmit() {
    this.saveInProgress = true

    const values = this.findContractorForm.value;
    const body = {
      maintenanceId: values.contractor,
      siteOwnerSkylarkId: this.siteOwnerId,
    };

    this.contractorService.createContractorSiteOwnerLink(body).subscribe(() => {
      this.notificationService.notify('success', 'Contractor linked to account');

      this.saveInProgress = false;
      this.router.navigate(['/' + this.routeRole + '/contractors/' + values.contractor + '/certificates']);
    }, error => {
      console.error(error);
      this.saveInProgress = false;
      this.notificationService.notify('danger', 'Could not create link, may already exist');

      throw error;
    });
  }
}
